module.exports = __webpack_public_path__ + "static/img/8256_phase_function_Paper_Points.3ac2f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8256_phase_function_Paper_Points.png
// module id = 74l4
// module chunks = 0